module.exports = __webpack_public_path__ + "static/revolution-slider-9fe1c1823787c77bd0df49a0d4833b06.jpg";